export const SCORE_SETTINGS_SEGMENT_TRANSLATION_KEYS = {
    all: "si.pages.score_settings.segment.all",
    shared: "si.pages.score_settings.segment.shared",
    private: "si.pages.score_settings.segment.private",
    applicableForMe: "si.pages.score_settings.segment.applicable_for_me",
} as const;

export const SCORE_SETTINGS_SCOPE_BADGE_KEYS = {
    sharedKey: "si.pages.score_settings.type.shared",
    privateKey: "si.pages.score_settings.type.private",
} as const;

export const SCORE_SETTINGS_ADD_RULE_TRANSLATION_KEYS = {
    privateKey: "si.pages.score_settings.add_rule.private",
    sharedKey: "si.pages.score_settings.add_rule.shared",
} as const;
